import React, { useEffect, useState } from 'react'
import { MdOutlineArrowRightAlt } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { axiosapi } from '../api/axiosapi';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
const MyBookingsPage = (props) => {
  const axiosPrivate = useAxiosPrivate();
  const [bookings, setbookings] = useState([]);
  const [date, setdate] = useState();

  useEffect(() => {

    const fetchBookings = async () => {
      try {
        const response = await axiosPrivate.post('/booking/findbyuser', { "userid": props.userid }, { credentials: "include" },);
        setbookings(response?.data?.bookingDetails);
      }
      catch (error) {
        console.log(error)
      }



    }
    fetchBookings();
  }, [])
  return (
    <>
      <div className="pl-2 mr-2 lg:mr-0 lg:pl-20 mt-8">
        <p className='text-gray-400 text-xl
        '>My Trips</p>

        {bookings?.map((x) => (
          <Link to={`/mybooking/${x._id}`} >
            < div className='border border-[#ffb74d] mt-8 px-2 py-2 lg:px-6 lg:w-[75%] rounded-lg' >
              <div className='flex items-center gap-2 font-size-[2rem] font-bold'>
                <span>{x.routeId.sourceCity}</span>
                <MdOutlineArrowRightAlt className="h-8 w-8" />
                <span>{x.routeId.destinationCity}</span>
                <p className='text-gray-400 pl-4'>{new Date(new Date(x.bookedFor).getTime() + 330 * 60 * 1000).toLocaleDateString('en-In', {
                  weekday: 'long',
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}</p>

              </div>
              <div className='flex items-center justify-between mt-4 '>
                <div className='flex flex-col items-center'>
                  <p className="font-semibold">{x.busId.name}</p>
                  <p className="text-gray-400">{x.busId.busType}</p>
                </div>
                <div className='flex flex-col items-center'>
                  <p className="font-semibold">{x.boardingPoint[0].time}</p>
                  <p className="text-gray-400">Reporting Time</p>
                </div>
                <div className='flex flex-col items-center'>
                  <p className="font-semibold">{x.seats.map((x) => (<span>{x.seatNumber}, </span>))}</p>
                  <p className="text-gray-400">Seat Number</p>
                </div>

              </div>

            </div>
          </Link>
        ))}

      </div >
    </>
  )
}

export default MyBookingsPage;
